"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PowerIcon = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var PowerIcon = function PowerIcon(_ref) {
  var color = _ref.color,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 24 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 24 : _ref$width,
      props = _objectWithoutProperties(_ref, ["color", "height", "width"]);

  return _react2.default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: color,
    height: height,
    width: width
  }, props), _react2.default.createElement("path", {
    d: "M12 21.75a8.85 8.85 0 0 1-6.26-15.1.74.74 0 0 1 1.06 0 .75.75 0 0 1 0 1.06A7.35 7.35 0 0 0 12 20.25a7.35 7.35 0 0 0 5.19-12.54.75.75 0 0 1 0-1.06.74.74 0 0 1 1.06 0A8.85 8.85 0 0 1 12 21.75zm.75-9.75V3a.75.75 0 0 0-1.5 0v9a.75.75 0 0 0 1.5 0z",
    "data-name": "Layer 1"
  }));
};

exports.PowerIcon = PowerIcon;